import { useState, useEffect } from 'react';
import { CONTENT_URL } from '../config/contentSource';

/**
 * Fetches site content from CONTENT_URL (JSON). All copy comes from this file.
 * Returns { content, loading, error }.
 */
export function useSiteContent() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    fetch(CONTENT_URL)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (!cancelled) {
          setContent(data);
          setError(null);
        }
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || 'Failed to load content');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [CONTENT_URL]);

  return { content, loading, error };
}
